<div class="visibility-tutorial">
  <h1>{{ "VISIBILITY_TUTORIAL.HEADING" | translate }}</h1>
  <p class="intro">{{ "VISIBILITY_TUTORIAL.INTRO" | translate }}</p>

  <div class="tutorial-item">
    <span class="material-symbols-outlined chart-icon">show_chart</span>
    <div class="tutorial-text">
      <h3>{{ "VISIBILITY_TUTORIAL.LINE_CHART_TITLE" | translate }}</h3>
      <p>{{ "VISIBILITY_TUTORIAL.LINE_CHART_TEXT" | translate }}</p>
    </div>
  </div>

  <div class="tutorial-item">
    <span class="material-symbols-outlined chart-icon">bar_chart</span>
    <div class="tutorial-text">
      <h3>{{ "VISIBILITY_TUTORIAL.BAR_CHART_TITLE" | translate }}</h3>
      <p>{{ "VISIBILITY_TUTORIAL.BAR_CHART_TEXT" | translate }}</p>
    </div>
  </div>

  <div class="tutorial-item">
    <span class="material-symbols-outlined chart-icon">videocam</span>
    <div class="tutorial-text">
      <h3>{{ "VISIBILITY_TUTORIAL.VIDEO_TITLE" | translate }}</h3>
      <p>{{ "VISIBILITY_TUTORIAL.VIDEO_TEXT" | translate }}</p>
    </div>
  </div>

  <div class="tutorial-item">
    <span class="material-symbols-outlined chart-icon">settings</span>
    <div class="tutorial-text">
      <h3>{{ "VISIBILITY_TUTORIAL.GEAR_TITLE" | translate }}</h3>
      <p>{{ "VISIBILITY_TUTORIAL.GEAR_TEXT" | translate }}</p>
    </div>
  </div>

  <div class="tutorial-item">
    <span class="material-symbols-outlined chart-icon">check_box</span>
    <div class="tutorial-text">
      <h3>{{ "VISIBILITY_TUTORIAL.OVERLAY_TITLE" | translate }}</h3>
      <p>{{ "VISIBILITY_TUTORIAL.OVERLAY_TEXT" | translate }}</p>
    </div>
  </div>

  <div class="show-again">
    <mat-checkbox *ngIf="!data.hideShowAgain" [(ngModel)]="dontShowAgain">
      {{ "VISIBILITY_TUTORIAL.DONT_SHOW_AGAIN" | translate }}
    </mat-checkbox>
    <button mat-raised-button color="primary" (click)="data.hideShowAgain ? dialogRef.close() : close()">{{ "VISIBILITY_TUTORIAL.CLOSE" | translate }}</button>
  </div>
</div>
